import useEntity from "../../hooks/useMembersGroupUser";
import MembersGroupUserDetail from "../../components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserDetail";
import MembersGroupUserScoped from "../../components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserScoped";
import MembersGroupUserTabs from "../../components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserTabs";
import { useGetMembersGroupUserQuery } from "../../apis/MembersGroupUser.api";
import { PrimaryMembersGroupUser } from "../../types/models/MembersGroupUser";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const MembersGroupUserDetailPage = () => {

    useTitle(t`Details Members Group User`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { membersGroupUserId: id } = useParams();

    const { data, refetch } = useGetMembersGroupUserQuery(PrimaryMembersGroupUser.fromPath(id))
    const { deleteMembersGroupUser } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteMembersGroupUser(data, '..')
    }, [data, deleteMembersGroupUser])

    if (id === 'scoped') {
        return (<MembersGroupUserScoped/>)
    }

    return (
        <Box data-testid="MembersGroupUser-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <MembersGroupUserDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" spacing={1} sx={{ justifyContent: "center", marginTop: "2em"}}>
                    
                    { 
        session.hasPermission('', 'applications/auth/entities/MembersGroupUsers/delete/view') &&
                        <Button size="small" color="error" variant="outlined" data-testid="MembersGroupUser-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <MembersGroupUserTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default MembersGroupUserDetailPage;
